import { Modal } from '@/components/Elements';
import { Button } from '@/components/TSX components';
import Tooltip from '@/components/Tooltip';
import 'rsuite/dist/rsuite.min.css';
import spinner from '@/features/settings/assets/spinner.gif';
import { useState } from 'react';
import useExploreStore from '../store/useExploreStore';
import { useShallow } from 'zustand/react/shallow';
import { useUpdateGlobalMergePath } from '../searchMetric/api/updateGlobalMergePath';

export const ChangeDefaultPathModal = ({
  isOpen,
  handleCloseModal,
  defPathModalDetail,
}) => {
  const handleCloseModalHandler = () => {
    handleCloseModal();
  };

  const updatePaths = useUpdateGlobalMergePath();

  const { setDrillDownPathsRefetch } = useExploreStore(
    useShallow((state) => ({
      setDrillDownPathsRefetch: state.setDrillDownPathsRefetch,
    }))
  );

  const [sending, setSending] = useState(false);

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleCloseModalHandler}
      title={'Mark Default'}
      headerClassName="pt-4 px-3"
      titleClassName="text-sm leading-5 text-brand-ai-200"
      topStripClassName="hidden"
      topBorderClassname="border-t-4 border-pv-warning-warning-text"
      className="max-w-xl w-120 relative"
      closeClassName="right-3 top-4"
    >
      <div className="flex flex-col gap-4 justify-between">
        <div className="p-3 pb-0 flex flex-col gap-2">
          <span className="text-xs text-pv-text-primary-text">
            This will mark the selected relationship as default for all related
            definitions involving the same tables.
          </span>
          <p className="w-full font-semibold text-pv-text-primary-text gap-1">
            Are you sure you want to proceed?
          </p>
        </div>
        <div className="border-t-2 mt-2 w-full">
          <div className="flex justify-between items-center py-4 px-3">
            <Button
              btnColor="ghost"
              onClick={handleCloseModalHandler}
              disabled={sending}
            >
              Cancel
            </Button>
            <Button
              disabled={sending}
              onClick={async () => {
                setSending(true);
                try {
                  const payload = {
                    drillDownSource: {
                      [defPathModalDetail.tableName]:
                        defPathModalDetail.path.map((p) => ({
                          from: p.from,
                          how: p.how,
                          left_on: p.left_on,
                          right_on: p.right_on,
                          to: p.to,
                        })),
                    },
                  };
                  await updatePaths.mutateAsync(payload);
                  setDrillDownPathsRefetch(true);
                  setSending(false);
                  handleCloseModalHandler();
                } catch {
                  setSending(false);
                }
              }}
            >
              {sending ? (
                <span className="flex items-center gap-2">
                  <img src={spinner} width="14px" height="14px" />
                  <span>Confirming</span>
                </span>
              ) : (
                `Confirm`
              )}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
